export const EVENT_SEARCH = 'search'
export const EVENT_CONTENT_OPENED = 'content_opened'
export const EVENT_RELATED_CONTENT_TAB_CLICKED = 'related_content_tab_clicked'
export const EVENT_MODAL_CLICKED = 'modal_clicked'
export const EVENT_MODAL_CLOSED = 'modal_closed'
export const EVENT_MODAL_IMPRESSIONS = 'modal_impressions'
export const EVENT_BANNER_CLICK = 'banner_clicked'
export const EVENT_ONBOARDING_COMPLETED = 'onboarding_completed'
export const EVENT_ONBOARDING_STARTED = 'onboarding_started'
export const EVENT_ONBOARDING_BOOK_CLICKED = 'onboarding_book_clicked'
export const EVENT_ONBOARDING_DISMISSED = 'onboarding_dismissed'
export const EVENT_ONBOARDING_LIKED_BOOKS = 'onboarding_liked_books'
export const EVENT_ONBOARDING_UNLIKED_BOOKS = 'onboarding_unliked_books'
export const EVENT_ONBOARDING_STEP_COMPLETED = 'onboarding_step_completed'
export const EVENT_DOWNLOAD_RUNNING_RECORD_TUTORIAL = 'tutorial_clicked'
export const EVENT_ONBOARDING_SELECTED_THEMES = 'onboarding_selected_themes'
export const EVENT_RUNNING_RECORD_CALCULATED = 'running_record_calculated'
export const EVENT_PUBLISHER_SHORTCUT = 'publisher_shortcut'
export const EVENT_AUTHOR_SHORTCUT = 'author_shortcut'
export const EVENT_TIME_USAGE_REPORT_GUIDE_DOWNLOADED = 'tutorial_clicked'
export const EVENT_TIME_USAGE_REPORT_RUBRIC_DOWNLOADED = 'tutorial_clicked'
export const EVENT_VIEW_FULL_COLLECTION_SHORTCUT =
  'view_full_collection_shortcut_clicked'
export const EVENT_CREATE_ACTIVITY_V3 = 'create_activity_v3_clicked'
export const EVENT_ACTIVITY_CATALOG_TAB_MY_ACTIVITIES =
  'activity_catalog_tab_my_activities_clicked'
export const EVENT_ACTIVITY_CATALOG_TAB_ARVORE_ACTIVITIES =
  'activity_catalog_tab_arvore_activities_clicked'
export const EVENT_ACTIVITY_CATALOG_TAB_ALL_ACTIVITIES =
  'activity_catalog_tab_all_activities_clicked'
export const EVENT_ACTIVITIES_REPORT_APPLY_ACTIVITY =
  'activities_report_apply_activity_clicked'
export const EVENT_ACTIVITIES_REPORT_ACTIVITY_CATALOG =
  'activities_report_activity_catalog_clicked'
export const EVENT_ACTIVITIES_TAB_ALL_ACTIVITIES =
  'activities_tab_all_activities_clicked'
export const EVENT_ACTIVITIES_TAB_MY_ACTIVITIES =
  'activities_tab_my_activities_clicked'
export const EVENT_ACTIVITIES_TAB_ARVORE_ACTIVITIES =
  'activities_tab_arvore_activities_clicked'
export const EVENT_BOOK_INTERMEDIATE_TAB_ACTIVITIES =
  'book_intermediate_tab_activities_clicked'
export const EVENT_BOOK_INTERMEDIATE_APPLY_ACTIVITY =
  'book_intermediate_apply_activity_clicked'
export const EVENT_BOOK_INTERMEDIATE_CREATE_ACTIVITY =
  'book_intermediate_create_activity_clicked'
export const EVENT_INDICATIONS_REPORT_VIEW = 'indications_report_view_clicked'
export const EVENT_RUNNING_RECORDS_DOWNLOAD_SHEET =
  'running_records_download_sheet_clicked'
export const EVENT_RUNNING_RECORDS_CALCULATOR =
  'running_records_calculator_clicked'
export const EVENT_RUNNING_RECORDS_METHOD_DETAILS =
  'running_records_method_details_clicked'
export const EVENT_RUNNING_RECORDS_PROGRESS_SHEET =
  'running_records_progress_sheet_clicked'
export const EVENT_RUNNING_RECORDS_FILTER_CHANGED =
  'running_records_filter_changed'
export const EVENT_RUNNING_RECORDS_BANNER_CLICKED =
  'running_records_banner_clicked'
export const EVENT_RUNNING_RECORDS_LISTEN_RECORDINGS =
  'audio_recording_dashboard_listen_recordings_clicked'
export const EVENT_RUNNING_RECORDS_PLAY_RECORDING =
  'audio_recording_dashboard_play_recording_clicked'
export const EVENT_RUNNING_RECORDS_EVALUATION_SELECTED =
  'audio_recording_dashboard_evaluation_selected'
export const EVENT_RUNNING_RECORDS_REGISTER_ASSESSMENT =
  'running_records_register_assessment_clicked'
export const EVENT_RUNNING_RECORDS_SAVE_ASSESSMENT =
  'running_records_save_assessment_clicked'
export const EVENT_RUNNING_RECORDS_EXPORT = 'running_records_export_clicked'
export const EVENT_RUNNING_RECORDS_HISTORY = 'running_records_history_clicked'
export const EVENT_AI_SUGGESTION_STATUS_CLICKED = 'ai_suggestion_status_clicked'
export const EVENT_AI_SUGGESTION_ACCEPTED = 'ai_suggestion_accepted'
export const EVENT_AI_SUGGESTION_IGNORED = 'ai_suggestion_ignored'
export const EVENT_AI_SUGGESTION_COMMENT_EDIT_CLICKED =
  'ai_suggestion_comment_edit_clicked'
export const EVENT_AI_SUGGESTION_COMMENT_SAVED = 'ai_suggestion_comment_saved'
export const EVENT_SUPERAUTOR_SHELF_VIEWED = 'superautor_shelf_viewed'
export const EVENT_SUPERAUTOR_SHELF_CTA_CLICKED = 'superautor_shelf_cta_clicked'
export const EVENT_SUPERAUTOR_SHELF_BOOK_CLICKED =
  'superautor_shelf_book_clicked'
export const EVENT_BOOK_CREATION_BANNER_VIEWED = 'book_creation_banner_viewed'
export const EVENT_BOOK_CREATION_BANNER_CLICKED = 'book_creation_banner_clicked'
export const EVENT_BOOK_CREATION_MODAL_APPLY_CLICKED =
  'book_creation_modal_apply_clicked'
export const EVENT_BOOK_CREATION_ADMIN_RESULTS_CLICKED =
  'book_creation_admin_results_clicked'
export const EVENT_PQL_WRITE_MODAL_VIEWED = 'superautor_pql_write_modal_viewed'
export const EVENT_PQL_WRITE_INDICATE_CLICKED =
  'superautor_pql_write_indicate_clicked'
export const EVENT_PQL_WRITE_READ_MYSELF_CLICKED =
  'superautor_pql_write_read_myself_clicked'
export const EVENT_PQL_WRITE_CREATE_LIST_CLICKED =
  'superautor_pql_write_create_list_clicked'
